import { FC, ReactNode } from 'react';

import CardContent from './CardContent';
import Flex from '../Flex';

// Local Typings
export interface CardFooterProps {
  leftContent?: ReactNode;
  rightContent?: ReactNode;
}

// Component Definition
const CardFooter: FC<CardFooterProps> = ({
  leftContent,
  rightContent,
}) => {
  return (
    <CardContent
      alignSelf="flex-end"
      className="card_card-footer"
    >
      <Flex
        alignItems="center"
        fullWidth
      >
        <Flex
          alignItems="center"
          flexWrap="wrap"
          fullWidth
          gapY={4}
          justifyContent="space-between"
        >
          <Flex
            alignItems="center"
            height={24}
          >
            {leftContent}
          </Flex>

          {rightContent && (
            <Flex
              alignItems="center"
              height={24}
            >
              {rightContent}
            </Flex>
          )}
        </Flex>
      </Flex>
    </CardContent>
  );
};

export default CardFooter;
